<template>
  <v-menu :nudge-width="150" offset-y :nudge-left="150">
    <template v-slot:activator="{ on }">
      <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Item operations</v-btn>
      <v-btn small icon v-on="on" v-on:click.prevent v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
    </template>
    <v-list dense>
      <v-list-item :to="{name:'InventoryItemsTransactions',params:{itemId:item.id},query:{siteId:siteId}}"><v-list-item-title>Transactions</v-list-item-title></v-list-item>
      <v-list-item v-if="item.onSalesOrder"
                    :to="{name:'SalesSalesOrders',query:{itemId:item.id,itemName:item.name}}"><v-list-item-title>Open sales orders</v-list-item-title></v-list-item>

      <v-list-item v-if="company.allowAudit && permission('audit')" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
      <template v-if="!readOnly">
        <v-divider v-if="item.type==='Item'"/>
        <v-list-item :to="{name:'InventoryItemsAdjustInventory',params:{itemId:item.id}}" v-if="item.type==='Item'"><v-list-item-title>Adjust inventory</v-list-item-title></v-list-item>
        <v-list-item :to="{name:'InventoryItemsTransferLot',params:{itemId:item.id}}" v-if="item.lotTracking"><v-list-item-title>Reassign lot</v-list-item-title></v-list-item>
        <v-list-item :to="{name:'InventoryItemsTransferSite',params:{itemId:item.id}}" v-if="item.type==='Item' && sites.length>1"><v-list-item-title>Move to site</v-list-item-title></v-list-item>
        <v-divider/>
        <v-list-item v-if="item.assembled && permission('production')" :to="{name:'ProductionAssemblyEditNew',params:{itemId:item.id}}"><v-list-item-title>Assemble</v-list-item-title></v-list-item>
        <v-list-item v-if="item.assembled && permission('production')" @click="printAssembly(item.id,{},true)"><v-list-item-title>Print assembly form</v-list-item-title></v-list-item>
        <v-list-item v-if="permission('buying')" :to="{name:'PurchasingPurchaseOrdersEditNew',params:{vendorId:item.preferredVendorId,itemType:'Item',itemId:item.id}}"><v-list-item-title>Create purchase order</v-list-item-title></v-list-item>
        <v-list-item v-if="permission('buying')" :to="{name:'PurchasingInventoryReceiptsEditNew',params:{vendorId:item.preferredVendorId,itemType:'Item',itemId:item.id}}"><v-list-item-title>Create inventory receipt</v-list-item-title></v-list-item>
        <v-divider v-if="permission('buying') || (item.assembled && permission('production'))"/>
        <generate-qr-code type="Item" :id="item.id" ask-quantity :quantityUnits="item.trackUnits" :quantityPrecision="item.precision" :ask-lot="item.lotTracking" :lots="lots(item)"/>
        <v-list-item :to="{name:'InventoryItemsEdit',params:{itemId:item.id}}"><v-list-item-title>Edit item</v-list-item-title></v-list-item>
        <v-list-item @click="$emit('delete')"><v-list-item-title>Delete item</v-list-item-title></v-list-item>
<!--
        <v-divider v-if="connectedToAccounting"/>
        <v-list-item v-if="connectedToAccounting" @click="$emit('updateFromAccountinng')"><v-list-item-title>Update from accounting</v-list-item-title></v-list-item>
-->
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import productionAssemblyPrintAssembly from '@/views/production/assembly/productionAssemblyPrintAssembly'
import generateQrCode from '@/components/GenerateQrCode'

export default {
  name: 'InventoryItemMenu',
  mixins: [productionAssemblyPrintAssembly],
  components: {generateQrCode},
  props: {
    item: {type:Object, required:true},
    siteId: {type:String, required:false, default:null},
    readOnly: {type:Boolean, required:false, default:false}
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    connectedToAccounting() {
      return this.company.connectedToAccounting;
    },
    sites() {
      return this.$store.getters.sites(true);
    }
  },
  methods: {
    permission(check) {
      return this.company.permissions.includes(check);
    },
    lots(item) {
      return item.sites.map(site => site.lot);
    }
  }
}
</script>